import { Button } from '@material-tailwind/react'
import React from 'react'

const StaffForm = ({ name, setName, email, setEmail, password, setPassword, contact, setContact, handleCreateUser, role, setRole }) => {
  return (
    <div className='mx-4 my-6 md:mx-6'>
      <div className='rounded-[28px] border border-slate-200 bg-white px-6 py-6 shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
        <div className='rounded-[24px] border border-slate-200 bg-[linear-gradient(180deg,_#ffffff,_#f8fafc)] p-5'>
          <div className='mb-5 border-b border-slate-100 pb-4'>
            <p className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Staff details</p>
            <p className='mt-1 text-sm text-slate-500'>Fill in the core account and role information for the staff member.</p>
          </div>

          <div className='grid gap-5 md:grid-cols-2'>
            <label className='block'>
              <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Full Name</span>
              <input value={name} onChange={(e) => setName(e.target.value)} placeholder='Staff member name' className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10' />
            </label>

            <label className='block'>
              <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Contact No</span>
              <input value={contact} onChange={(e) => setContact(e.target.value)} placeholder='Phone number' className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10' />
            </label>

            <label className='block'>
              <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Email</span>
              <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Email address' type='email' className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10' />
            </label>

            <label className='block'>
              <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Password</span>
              <input value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Create password' type='password' className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10' />
            </label>

            <label className='block md:col-span-2'>
              <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Role</span>
              <select value={role} onChange={(e) => setRole(e.target.value)} className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'>
                <option value=''>Select staff role</option>
                <option value='Delivery Boy'>Delivery Boy</option>
                <option value='Delivery Partner'>Delivery Partner</option>
                <option value='Operational Manager'>Operational Manager</option>
                <option value='admin'>Admin</option>
              </select>
            </label>
          </div>
        </div>

        <div className='mt-6 flex justify-end'>
          <Button onClick={handleCreateUser} className='rounded-full bg-[#f97316] px-8 py-3 text-sm font-[GilroyBold] text-white shadow-[0_14px_30px_rgba(249,115,22,0.2)] hover:bg-[#ea580c]'>
            Create Staff
          </Button>
        </div>
      </div>
    </div>
  )
}

export default StaffForm
